//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
import ManageApply from "@/listing-app/mixins/ManageApply";

import Loader from "@/listing-app/components/Loader";
import Error from "@/listing-app/components/Error";

import Header from "@/listing-app/components/detail/Header";
import Images from "@/listing-app/components/detail/Images";
import Layouts from "@/listing-app/components/detail/Layouts";
import Upgrades from "@/listing-app/components/detail/Upgrades";
import Promo from "@/listing-app/components/detail/Promo";
import Summary from "@/listing-app/components/detail/Summary";
import Features from "@/listing-app/components/detail/Features";
import Legal from "@/listing-app/components/detail/Legal";
import Footer from "@/listing-app/components/detail/Footer";

export default {
  name: "Detail",
  mixins: [ManageApply],
  components: {
    appLoader: Loader,
    appError: Error,
    appHeader: Header,
    appImages: Images,
    appLayouts: Layouts,
    appUpgrades: Upgrades,
    appPromo: Promo,
    appSummary: Summary,
    appFeatures: Features,
    appLegal: Legal,
    appFooter: Footer,
  },
  data() {
    return {
      endpoint: document
        .querySelector("#detailEndpointURL")
        .getAttribute("value"),
      data: {},
      slug: undefined,
      layout: undefined,
      upgrade: undefined,
      margin: undefined,
    };
  },
  computed: {
    ...mapGetters(["read"]),
    loaded() {
      return this.read("loaded");
    },
    error() {
      return this.read("error");
    },
    bdrm() {
      let bdrm;
      this.data.Layouts.forEach((layout) => {
        if (layout.ID == this.layout) {
          bdrm = layout;
        }
      });
      return bdrm;
    },
    price() {
      let price = {};
      if (this.upgrade) {
        this.bdrm.Upgrades.forEach((upgrade) => {
          if (upgrade.ID == this.upgrade) {
            price.standard = upgrade.Price;
            price.adjusted = upgrade.AdjustedPrice;
          }
        });
      } else {
        price.standard = this.bdrm.Price;
        price.adjusted = this.bdrm.AdjustedPrice;
      }
      return price;
    },
    priceMask() {
      let priceMask;
      if (this.upgrade) {
        this.bdrm.Upgrades.forEach((upgrade) => {
          if (upgrade.ID == this.upgrade) {
            priceMask = upgrade.PriceMask;
          }
        });
      } else {
        priceMask = this.bdrm.PriceMask;
      }
      return priceMask;
    },
    availability() {
      let availability;
      if (this.upgrade) {
        this.bdrm.Upgrades.forEach((upgrade) => {
          if (upgrade.ID == this.upgrade) {
            availability = upgrade.Availability;
          }
        });
      } else {
        availability = this.bdrm.Availability;
      }
      return availability;
    },
    summary() {
      let detail;
      if (this.upgrade) {
        this.bdrm.Upgrades.forEach((upgrade) => {
          if (upgrade.ID == this.upgrade) {
            detail = upgrade.ApplicationDetail;
          }
        });
      } else {
        detail = this.bdrm.ApplicationDetail;
      }
      return detail;
    },
    promotion() {
      let promotion;
      if (this.upgrade) {
        this.bdrm.Upgrades.forEach((upgrade) => {
          if (upgrade.ID == this.upgrade) {
            promotion = upgrade.Promotion;
          }
        });
      } else {
        promotion = this.bdrm.Promotion;
      }
      return promotion;
    },
    features() {
      let features;
      if (this.upgrade) {
        this.bdrm.Upgrades.forEach((upgrade) => {
          if (upgrade.ID == this.upgrade) {
            features = upgrade.Features;
          }
        });
      } else {
        features = this.bdrm.Features;
      }
      return features;
    },
  },
  methods: {
    ...mapActions(["set"]),
    init() {
      let href = window.location.href;
      let regex = /(?:detail\/)(.*)/;
      let slug;

      this.set({ muta: "loaded", data: false });
      this.set({ muta: "error", data: false });

      //if there is no detailApi (you did not come here from the listing page), set it to the url slug
      if (!this.read("detailApi")) {
        slug = regex.exec(href)[1];
        this.set_slug(slug);
        this.set({ muta: "detailApi", data: this.endpoint + this.slug });
      }
      this.load_data();
    
      document.getElementById("header-apply")?.setAttribute("hidden", "hidden");
    },
    load_data() {
      this.$api
        .get(this.read("detailApi"))
        .then((rsp) => {
          if (rsp) {
            if (Object.keys(rsp).length == 0) {
              this.$router.push({ path: "/", hash: "", query: { detailError: true } });
            } else {
              this.data = rsp;
              this.set({ muta: "theme", data: this.data.Theme });
              this.set_slug(this.slug || this.data.UrlSlug);
              this.match_slug()
                .then((res) => {
                  this.set({ muta: "loaded", data: true });
                })
                .catch((res) => {
                  this.$router.replace("/");
                });
            }
          } else {
            this.set({ muta: "error", data: true });
          }
        })
        .catch((err) => {
          console.log(err);
          this.set({ muta: "error", data: true });
        })
        .finally(() => {
          console.timeEnd("load_detail");
        });
    },
    match_slug() {
      return new Promise((resolve, reject) => {
        this.data.Layouts.some((layout) => {
          //loop over layouts
          return layout.Upgrades.some((upgrade) => {
            //loop over upgrades under layout
            if (upgrade.UrlSlug == this.slug) {
              //if upgrade is match
              let unset =
                upgrade.ID == this.upgrade &&
                layout.Upgrades.every((upgrade) => upgrade.ID != layout.ID); // was this option previously selected && are all ID's for this set unique
              this.layout = layout.ID; //set layout selection to this upgrades parent layout
              this.upgrade = unset
                ? (this.set_slug(layout.UrlSlug), undefined)
                : upgrade.ID; //deselect and set slug to layout OR set upgrade selection to this upgrade
              resolve(true); //resolve promise
              return true; //stop processing the upgrades array.some() loop
            }
            return false; //no match, progress to next upgrade
          })
            ? true
            : (() => {
                // turnary statment either returns true to the outer function, or the truthyness of this self invoking function
                //if the upgrades array.some() loop returns true, the outer loop stops processing
                //if upgrades array.some() loop did not return true, the following code is processed
                if (layout.UrlSlug == this.slug) {
                  //if layout is a match
                  this.layout = layout.ID; //set layout selection to this layout
                  this.upgrade = undefined; // no upgrade match, unset
                  resolve(true); //resolve promise
                  return true; //stop processing the layouts array.some() loop
                }
                return false; //no match, progress to next layout
              })();
        }); //if we have gotten to this point, there was no match
        reject(false); //reject promise
      });
    },
    set_slug(slug) {
      if (slug != this.slug) {
        slug = slug || this.slug;
        this.slug = slug;
        this.$router.replace(`/detail/${slug}`);
      }
    },
    update(payload) {
      this.set_slug(payload.slug);
      this.match_slug();
    },
  },
  created() {
    console.time("load_detail");
    this.init();
    this.hide_apply();
  },
};
